import { render, staticRenderFns } from "./subscriber-dialog.vue?vue&type=template&id=2619a5c0"
import script from "./subscriber-dialog.vue?vue&type=script&lang=ts"
export * from "./subscriber-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports